import React from "react";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "../config";
import LocalizedLink from "../components/LocalizedLink";

export type FaqStickyLinkProps = {
  className?: string;
};

/** 右固定 FAQ 導線（`.faq-wrapper` は subpage.less / banner.less） */
const FaqStickyLink: React.FC<FaqStickyLinkProps> = ({ className }) => {
  const { t } = useTranslation();
  const rootClass = ["faq-wrapper", className].filter(Boolean).join(" ");

  return (
    <div className={rootClass}>
      <LocalizedLink
        to="/faq"
        className="faq-wrapper-content-link"
        aria-label="FAQ"
      >
        <span className="faq-wrapper-content-title">FAQ</span>
        <span className="faq-wrapper-content-description">{t("home.more_details")}</span>
        <div>
          <img
            src={getImageUrl("/image/icon_arrow_white.png")}
            alt=""
          />
        </div>
      </LocalizedLink>
    </div>
  );
};

export default FaqStickyLink;
